module.exports = __webpack_public_path__ + "img/logo.4054b8aa.svg";